<template lang="pug">
  .journals-list
    v-scroll-y-transition(leave-absolute)
      v-skeleton-loader(
        v-if="loading"
        type="list-item-two-line@3"
      )
    v-list(nav)
      v-list-item.grey.lighten-5.pa-3.pb-0.sdo-radius(
        v-for="(journal, idx) in journals"
        :key="idx"
      )
        v-list-item-content.py-0
          .d-flex.mb-4.align-center
            div
              div.caption Попытка № {{ journals.length - idx }}
              span.caption: strong {{ journal.journal_answer.updated_at | dp('dd MMMM HH:mm') }}
            v-chip.ml-auto.text-caption(
              small
              :color="`${TASK_STATUS_COLORS[journal.status]}`"
            )
              div(
              ) {{ TASK_STATUS_NAMES[journal.status] }}

          .text-body-2.mb-1(
            v-if="journal.error_task_units.length"
          )
            span Неправильных ответов:
            span.ml-2 {{ journal.error_task_unit_count }}
            v-btn.ml-1.pb-1(
              small icon color="primary"
              @click.stop="handleDetailTask(journal)"
            ): v-icon(size="20") mdi-help-circle-outline

          template(v-if="!isConsult")
            v-list-item-group(
              v-if="journal.comment"
            )
              v-alert.pa-0.mb-2(
                style="border-radius: 8px !important;"
                color="primary" text outlined
                )
                  v-list-item.d-flex.flex-column.align-start.pt-2.pb-2(
                    style='min-height: 0px'
                    @click.stop.prevent
                  )
                    template(#default="{ active }")
                      .d-flex.text-start.align-self-center.fill-width
                        v-icon(small color="primary").mr-1.pt-1 mdi-comment-text-outline
                        .primary--text.caption Комментарий:
                        v-spacer
                        v-icon.ml-auto(
                          color="primary"
                          size="18"
                        ) {{ active ? 'mdi-chevron-up' : 'mdi-chevron-down'}}
                      v-expand-transition
                        div(v-if="active")
                          .pt-3
                            span.mr-2 -
                            span.text-body-2(
                              v-html="journal.comment"
                            )
            //- template(v-if="journal.error_comments")
            //-   span.text-body-2.black--text.
            //-     На основании анализа выполненного задания рекомендуется обратить внимание на:
            //-   .text-caption.black--text.mt-1(
            //-     v-for="message in journal.error_comments"
            //-   ) - {{ message }}
          .mb-2(v-if="+journal.mark")
            span.text-body-2  Оценка:
            span.ml-2.text-h6 {{ journal.mark }}

</template>

<script>
import { format } from 'date-fns';

import {
  TASK_STATUS_NAMES,
  TASK_STATUS_COLORS,
} from '@/utils/constants';

export default {
  props: {
    task: { type: Object, required: true },
    userId: { type: [String, Number], default: null },
    isConsult: { type: Boolean, default: false },
  },
  data: () => ({
    TASK_STATUS_NAMES,
    TASK_STATUS_COLORS,

    journals: [],
    loading: true,
  }),
  created() {
    this.getJournal();
  },
  methods: {
    handleDetailTask(journal) {
      // if (this.isConsult) this.toCheckTask(journal.journal_answer.id, journal.group_id);
      // else
      this.showDetailWrongAnsewer(journal.error_task_units);
    },
    toCheckTask(journalid, groupId) {
      const routeData = this.$router.resolve({
        name: 'TaskCheck',
        params: { id: this.task.id },
        query: {
          journal: journalid,
          user: this.userId,
          group: groupId,
        },
      });
      window.open(routeData.href, '_blank');
    },
    getDate(journal) {
      const date = new Date(journal.journal_answer.updated_at);
      return format(date, 'dd.MM.yyyy, HH:mm:ss');
    },
    getJournal() {
      const params = {
        expand: 'journal_answer,error_task_unit_count,error_comments,error_task_units',
        'search[task_id]': this.task.id,
        'search[user_id]': this.userId,
      };
      this.$rHandler(
        this.$api.journal.getJournalTasks({ params }),
        ({ data }) => {
          this.journals = data.data.reverse();
          this.loading = false;
        },
      );
    },
    showDetailWrongAnsewer(units) {
      this.$modals.show('generic-controller', {
        title: 'Неправильные ответы даны на следующие вопросы:',
        component: 'VDataTable',
        dialogProps: {
          width: 800,
        },
        'component-props': {
          items: units.map((i) => ({ title: i })),
          headers: [{ text: 'Название', value: 'title' }],
          'hide-default-footer': true,
          'hide-default-header': true,
          'items-per-page': 1000,
        },
      });
    },
  },
};
</script>
